// tslint:disable:max-line-length
import * as React from 'react';

import { createIcon } from '../icon';

export const RegionPureIcon = createIcon(`
  <svg version="1.1" id="Слой_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="120" height="120"
    viewBox="0 0 120 120" style="enable-background:new 0 0 120 120;" xml:space="preserve">
  <style type="text/css">
    .region0{fill:none;stroke:#0A055F;stroke-width:2.6562;stroke-miterlimit:10;}
    .region1{fill:none;stroke:#FF4114;stroke-width:2.6562;stroke-miterlimit:10;}
  </style>
  <g>
    <path class="region0" d="M117.5,60c0,31.7-25.8,57.5-57.5,57.5S2.5,91.7,2.5,60S28.3,2.5,60,2.5S117.5,28.3,117.5,60z"/>
    <path class="region0" d="M66.3,46.7c0-9,7.3-16.3,16.3-16.3s16.3,7.3,16.3,16.3c0,12.6-16.3,34.8-16.3,34.8s-3.8-5.3-7.6-12.1"/>
    <path class="region0" d="M88,46.7c0,3-2.4,5.5-5.5,5.5s-5.5-2.4-5.5-5.5s2.4-5.5,5.5-5.5S88,43.7,88,46.7z"/>
    <path class="region0" d="M45.1,69.6c-3.9,6.8-7.7,12-7.7,12S21.1,58.7,21.1,46.7c0-9,7.3-16.3,16.3-16.3s16.3,7.3,16.3,16.3"/>
    <path class="region0" d="M42.9,46.7c0,3-2.4,5.5-5.5,5.5S32,49.8,32,46.7s2.4-5.5,5.5-5.5S42.9,43.7,42.9,46.7z"/>
    <path class="region1" d="M76.3,62.1C76.3,74.7,60,96.9,60,96.9S43.7,74,43.7,62.1c0-9,7.3-16.3,16.3-16.3S76.3,53.1,76.3,62.1z"/>
    <path class="region1" d="M65.5,62.1c0,3-2.4,5.5-5.5,5.5s-5.5-2.4-5.5-5.5s2.4-5.5,5.5-5.5S65.5,59.1,65.5,62.1z"/>
  </g>
  </svg>
`);

export const RegionIcon: React.SFC<{ iconClassName?: string }> = (props: { iconClassName?: string }) => (
  <RegionPureIcon className={props.iconClassName} />
);

RegionIcon.displayName = 'RegionIcon';
